/* @flow */

/*
 * manages picking icon for an expert opinion
 */

import type { RootState, Action } from '../types'

export const STATE_KEY = 'pollBuilderIsIconPickerOpen'

export const OPEN_ICON_PICKER = 'opinary/OPEN_ICON_PICKER'
export const CLOSE_ICON_PICKER = 'opinary/CLOSE_ICON_PICKER'
export const OPEN_ICON_CREATION = 'opinary/OPEN_ICON_CREATION'
export const CLOSE_ICON_CREATION = 'opinary/CLOSE_ICON_CREATION'

export const OPEN_SNIPPET_CREATION = 'opinary/OPEN_SNIPPET_CREATION'
export const OPEN_SNIPPET_EDITOR = 'opinary/OPEN_SNIPPET_EDITOR'
export const CLOSE_SNIPPET_INFO = 'opinary/CLOSE_SNIPPET_INFO'

export function openSnippetCreation(): Action {
  return {
    type: OPEN_SNIPPET_CREATION,
  }
}

export function openSnippetEditor(): Action {
  return {
    type: OPEN_SNIPPET_EDITOR,
  }
}

export function closeSnippetInfo(): Action {
  return {
    type: CLOSE_SNIPPET_INFO,
  }
}

export function openIconPicker(): Action {
  return {
    type: OPEN_ICON_PICKER,
  }
}

export function closeIconPicker(): Action {
  return {
    type: CLOSE_ICON_PICKER,
  }
}

export function openIconCreation(): Action {
  return {
    type: OPEN_ICON_CREATION,
  }
}

export function closeIconCreation(): Action {
  return {
    type: CLOSE_ICON_CREATION,
  }
}

export function selectIsIconPickerOpen(state: RootState): boolean {
  return state[STATE_KEY].picker
}

export function selectIsIconCreationOpen(state: RootState): boolean {
  return state[STATE_KEY].creation
}

export function selectIsSnippetCreationOpen(state: RootState): boolean {
  return state[STATE_KEY].snippetInfo || state[STATE_KEY].picker
}

export function selectIsSnippetInfoOpen(state: RootState): boolean {
  return state[STATE_KEY].snippetInfo
}

type StateType = {
  picker: boolean,
  creation: boolean,
  snippetCreation: boolean,
  snippetInfo: boolean,
}

const initialState: StateType = {
  picker: false,
  creation: false,
  snippetInfo: false,
  snippetCreation: false,
}

export default function reducer(
  state: StateType = initialState,
  action: Action
): StateType {
  switch (action.type) {
    case OPEN_SNIPPET_CREATION:
      return {
        ...state,
        picker: true,
        snippetInfo: true,
      }
    case OPEN_SNIPPET_EDITOR:
      return {
        ...state,
        creation: false,
        picker: false,
        snippetInfo: true,
      }
    case CLOSE_SNIPPET_INFO:
      return {
        ...state,
        snippetInfo: false,
        creation: false,
        picker: false,
      }
    case OPEN_ICON_PICKER:
      return {
        ...state,
        picker: true,
      }
    case CLOSE_ICON_PICKER:
      return {
        ...state,
        picker: false,
      }
    case OPEN_ICON_CREATION:
      return {
        ...state,
        picker: false,
        creation: true,
      }
    case CLOSE_ICON_CREATION:
      return {
        ...state,
        creation: false,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/pollBuilderIconPicker.js